package org.example.project

import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.ComposeViewport
import kotlinx.browser.window
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.launch
import org.example.project.firebase.AuthManager
import org.example.project.firebase.FirebaseInitializer
import org.example.project.firebase.FirestoreManager

@OptIn(ExperimentalComposeUiApi::class)
fun main() {
    FirebaseInitializer.initialize()
    window.addEventListener("pagehide") {
        val uid =
            AuthManager.currentUserId()
        if (uid != null) {
            CoroutineScope(Dispatchers.Default).launch {
                FirestoreManager.setOnline(
                    uid,
                    false
                )
            }
        }
    }
    ComposeViewport {
        App()
    }
}
